import React from 'react';
import { SkipForward } from 'lucide-react';
import { Button } from './ui/button';
import { useToast } from '@/hooks/use-toast';

interface SkipButtonProps {
  count: number;
  onSkip: () => void;
  skipMode?: boolean;
  onCancelSkip?: () => void;
}

const SkipButton: React.FC<SkipButtonProps> = ({ count, onSkip, skipMode, onCancelSkip }) => {
  const { toast } = useToast();

  const handleClick = () => {
    // If already in skip mode, cancel it
    if (skipMode && onCancelSkip) {
      onCancelSkip();
      toast({
        title: 'Skip Cancelled',
        description: 'Skip mode cancelled',
        variant: 'default',
      });
      return;
    }

    // Otherwise, activate skip mode
    if (count > 0) {
      onSkip();
      toast({
        title: 'Skip Ready',
        description: 'Click on a goal to skip it and get a new word',
        variant: 'warning',
      });
    }
  };

  return (
    <div className="flex items-center justify-center">
      <Button
        variant="outline"
        size="sm"
        className={`flex items-center gap-2 ${count === 0 && !skipMode ? 'opacity-50' : ''} ${
          skipMode ? 'bg-amber-500 hover:bg-amber-600 text-white' : ''
        }`}
        disabled={count === 0 && !skipMode}
        onClick={handleClick}
      >
        <SkipForward className="h-4 w-4" />
        <span>{skipMode ? 'Cancel' : count}</span>
      </Button>
    </div>
  );
};

export default SkipButton;
